// frontend/src/components/newui/NewNotificationsMenu.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Bell, Trash2, Trophy, X } from 'lucide-react';
import { useSocket } from '../../contexts/SocketContext';

const NewNotificationItem = ({ notification, onRead, onDelete, onMarkTournamentAsRead }) => {
    const navigate = useNavigate();

    const handleClick = () => {
        if (notification.link) {
            // Si es una notificación de torneo, eliminar todas las del mismo torneo
            if (notification.tournamentId) {
                onMarkTournamentAsRead(notification.tournamentId);
                console.log(`🏆 Navegando a torneo ${notification.tournamentId} desde menú (New UI) - eliminando todas sus notificaciones`);
            } else {
                // Para notificaciones que no son de torneo, comportamiento normal
                onRead(notification.id);
                onDelete(notification.id);
            }

            // Navegar con estado para indicar origen de notificación
            navigate(notification.link, {
                state: { fromNotification: true }
            });
        }
    };

    return (
        <div className={`p-4 ${notification.read ? 'bg-white' : 'bg-blue-50'} hover:bg-gray-50`}>
            <div className="flex items-start">
                <div className="flex-shrink-0 text-primary">
                    {notification.type.includes('TOURNAMENT') ? (
                        <Trophy className="w-5 h-5" />
                    ) : (
                        <Bell className="w-5 h-5" />
                    )}
                </div>
                <div className="ml-3 flex-1">
                    <div className="flex items-start justify-between">
                        <div>
                            <p className="text-sm font-medium text-gray-900">
                                {notification.title}
                            </p>
                            <p className="text-sm text-gray-500 mt-1">
                                {notification.message}
                            </p>
                            <p className="text-xs text-gray-400 mt-1">
                                {new Date(notification.createdAt).toLocaleString('es-AR')}
                            </p>
                        </div>
                        <button
                            onClick={() => onDelete(notification.id)}
                            className="ml-4 text-gray-400 hover:text-gray-500"
                        >
                            <X className="w-4 h-4" />
                        </button>
                    </div>
                    {notification.link && (
                        <button
                            onClick={handleClick}
                            className="mt-2 text-sm text-primary hover:text-primary-light"
                        >
                            Ver detalles
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

const NewNotificationsMenu = ({ isOpen, onClose }) => {
    const { notifications, unreadCount, markAsRead, deleteNotification, clearAllNotifications, markTournamentNotificationsAsRead } = useSocket();

    if (!isOpen) return null;

    return (
        <div className="absolute right-0 mt-2 w-96 bg-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5 z-50">
            <div className="p-4 border-b">
                <div className="flex items-center justify-between">
                    <h2 className="text-lg font-medium text-gray-900">Notificaciones</h2>
                    {notifications.length > 0 && (
                        <button
                            onClick={clearAllNotifications}
                            className="text-sm text-gray-500 hover:text-gray-700 flex items-center"
                        >
                            <Trash2 className="w-4 h-4 mr-1" />
                            Limpiar todo
                        </button>
                    )}
                </div>
                {unreadCount > 0 && (
                    <p className="text-sm text-gray-500 mt-1">
                        {unreadCount} sin leer
                    </p>
                )}
            </div>

            <div className="max-h-96 overflow-y-auto">
                {notifications.length === 0 ? (
                    <div className="p-4 text-center text-gray-500">
                        No hay notificaciones
                    </div>
                ) : (
                    <div className="divide-y divide-gray-100">
                        {notifications.map(notification => (
                            <NewNotificationItem
                                key={notification.id}
                                notification={notification}
                                onRead={markAsRead}
                                onDelete={deleteNotification}
                                onMarkTournamentAsRead={markTournamentNotificationsAsRead}
                            />
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default NewNotificationsMenu;
